export default __webpack_public_path__ + "static/media/founder-tanisha-ferguson.27bd1981.webp";